module.exports = __webpack_public_path__ + "img/train-red.384588b8.svg";